<script setup lang="ts"></script>

<template>
  <div class="main-layout" />
</template>

<style scoped></style>
